import React, { FC, useContext, useEffect } from "react";
import { useLoaderData } from "react-router-dom";
import { ContextHeader } from "../../components/header/secondary";
import { UserIncident } from "../../../domain/incident/Incident";
import { UserIncidentView } from "./components/view";
import { DashboardHeaderContext } from "../../../hook/header";

import { useStyleContext } from "../../context/StyleContext";

export const IncidentPage: FC = () => {
  const data = useLoaderData() as UserIncident;
  /* eslint-disable */
  const dashboardHeaderContext = useContext(DashboardHeaderContext);
  useEffect(() => {
    dashboardHeaderContext.setTheme({
      className: "bg-gray-100",
      title: "Incidencia",
      dark: false,
      subtitle: data.owner?.displayName,
      homeAsUpEnabled: true,
    });
  }, []);
  const { stylePage } = useStyleContext();
  /* eslint-enable */
  return (
    <div className={"w-full h-full flex flex-col overflow-hidden px-3"}>
      <ContextHeader
        breadcrumbItems={[
          {
            label: "Incidencias",
            path: "/dashboard/incident-group",
          },
          {
            label: "...",
            active: true,
          },
        ]}
        title={"Registro de Incidencia"}
        stylePage={stylePage}
      />
      <div className={"p-3 flex-1 w-full overflow-y-auto"}>
        <UserIncidentView incident={data} />
      </div>
    </div>
  );
};
